module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('div', {
    attrs: {
      "id": "List_of_Photographs"
    }
  }, [_c('p', {
    staticClass: "fm-title"
  }, [_c('a', {
    attrs: {
      "id": "page_vi"
    }
  }, [_c('b', [_vm._v("List of Photographs")])])]), _c('a', {
    attrs: {
      "id": "page_vi"
    }
  }), _c('p', {
    staticClass: "img-para"
  }, [_c('a', {
    attrs: {
      "id": "page_vi"
    }
  }), _c('span', {
    attrs: {
      "href": "#/xhtml/14_Chapter04#ufig_1",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Tunisia. Sports team. Paul is second from right.")])]), _vm._v(" "), _c('p', {
    staticClass: "img-para"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/14_Chapter04#ufig_3",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Tunisia. Sports team. Paul in foreground, squatting.")])]), _vm._v(" "), _c('p', {
    staticClass: "img-para"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/14_Chapter04#ufig_2",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Paul Martelli, July 1945. Unfortunately no photos survive for Paul’s Eastern Front service.")])]), _vm._v(" "), _c('p', {
    staticClass: "img-para"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/14_Chapter04#ufig_5",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("At the Peripheral Quarter.")])]), _vm._v(" "), _c('p', {
    staticClass: "img-para"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/14_Chapter04#ufig_4",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Demonstration on the boat.")])]), _vm._v(" "), _c('p', {
    staticClass: "img-para"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/14_Chapter04#ufig_7",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("En route towards Gia Lam.")])]), _vm._v(" "), _c('p', {
    staticClass: "img-para"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/14_Chapter04#ufig_6",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Hanoi. Towards the Doumer Bridge.")])]), _vm._v(" "), _c('p', {
    staticClass: "img-para"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/14_Chapter04#ufig_8",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("During ‘Operation Delta’.")])]), _vm._v(" "), _c('p', {
    staticClass: "img-para"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/14_Chapter04#ufig_9",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Sub-sector of Phu Lo. Viet Minh prisoners laying foundations.")])]), _vm._v(" "), _c('p', {
    staticClass: "img-para"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/14_Chapter04#ufig_10",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Sub-sector of Phu Lo. Fortifications from Paul’s project.")])]), _vm._v(" "), _c('p', {
    staticClass: "img-para"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/14_Chapter04#ufig_11",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Sub-sector of Phu Lo. Vietnamese partisans, pro-French. Paul at right.")])]), _vm._v(" "), _c('p', {
    staticClass: "img-para"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/14_Chapter04#ufig_12",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Sub-sector of Phu Lo. Advanced emplacement #6. Paul with ‘cail’s’ aide.")])]), _vm._v(" "), _c('p', {
    staticClass: "img-para"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/14_Chapter04#ufig_13",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Sub-sector of Phu Lo. Block house near Song Ca Lo River.")])]), _vm._v(" "), _c('p', {
    staticClass: "img-para"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/14_Chapter04#ufig_15",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Sub-sector of Phu Lo. Advanced emplacement #6 along Song Ca Lo River.")])]), _vm._v(" "), _c('p', {
    staticClass: "img-para"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/14_Chapter04#ufig_14",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Paul with ‘cail’ (village chief) To Van Phuc.")])]), _vm._v(" "), _c('p', {
    staticClass: "img-para"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/14_Chapter04#ufig_16",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Sub-sector of Phu Lo. Surveying fortifications.")])]), _vm._v(" "), _c('p', {
    staticClass: "img-para"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/14_Chapter04#ufig_17",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Paul at Phu Lo village.")])]), _vm._v(" "), _c('p', {
    staticClass: "img-para"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/14_Chapter04#ufig_18",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Sub-sector of Phu Lo. Working on fortifications under Paul’s control.")])]), _vm._v(" "), _c('p', {
    staticClass: "img-para"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/14_Chapter04#ufig_19",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Peripheral Quarter. Back from a mission.")])]), _vm._v(" "), _c('p', {
    staticClass: "img-para"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/14_Chapter04#ufig_20",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Advance base of Dac Tai.")])]), _vm._v(" "), _c('p', {
    staticClass: "img-para"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/14_Chapter04#ufig_21",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Dac Tai. Fortifications.")])]), _vm._v(" "), _c('p', {
    staticClass: "img-para"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/14_Chapter04#ufig_22",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Dac Tai. Paul at the start of a patrol.")])]), _vm._v(" "), _c('p', {
    staticClass: "img-para"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/14_Chapter04#ufig_23",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Paul, at right, with a friend who would end up at Poulo Condor’s prison.")])]), _vm._v(" "), _c('p', {
    staticClass: "img-para"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/14_Chapter04#ufig_24",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Dac Tai. Paul’s combat emplacement. 57mm cannon on turret.")])]), _vm._v(" "), _c('p', {
    staticClass: "img-para"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/14_Chapter04#ufig_25",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Back from a patrol – note the bullet-hole in the windshield. Photo taken at the Peripheral Quarter.")])]), _vm._v(" "), _c('p', {
    staticClass: "img-para"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/14_Chapter04#ufig_26",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Radio tower at Phu Lo.")])]), _vm._v(" "), _c('p', {
    staticClass: "img-para"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/14_Chapter04#ufig_27",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Paul’s friend, Super TD tank driver ‘Souché’.")])]), _vm._v(" "), _c('p', {
    staticClass: "img-para"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/14_Chapter04#ufig_29",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Sub-sector of Phu Lo. 37mm cannon on turret.")])]), _vm._v(" "), _c('p', {
    staticClass: "img-para"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/14_Chapter04#ufig_28",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Small daytime-only control post. Paul at right.")])]), _vm._v(" "), _c('p', {
    staticClass: "img-para"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/14_Chapter04#ufig_30",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Gymnastics at Hanoi.")])]), _vm._v(" "), _c('p', {
    staticClass: "img-para"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/14_Chapter04#ufig_31",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Paul on motorbike duty.")])])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-b51eee8e","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/xhtml/07_List_of_Photographs.vue
// module id = 72
// module chunks = 0